module.exports = __webpack_public_path__ + "img/65.a01614af.jpg";